import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

interface TotalDataProps {
  hlanguage: any;
}

const base_Url = process.env.REACT_APP_BASE_URL;

const MinisterNew: React.FC<TotalDataProps> = ({ hlanguage }) => {
  const ministers = hlanguage?.minister || [];

  return (
    <div className="container-fluid py-5">
      <div className="container">
        {/* Header */}
        <div className="text-center mb-5">
          <h1
            className="display-5 fw-bold"
            style={{
              fontSize: "clamp(1.5rem, 4vw, 2.5rem)",
              color: "#1A5319",
            }}
          >
            <span>{hlanguage?.minister_header1}</span>
            <p
              className="text-secondary"
              style={{
                fontSize: "clamp(1rem, 3vw, 1.4rem)",
                color: "#696969",
                fontWeight: "500",
              }}
            >
              {hlanguage?.minister_header2}
            </p>
          </h1>
        </div>

        {/* Officials Grid */}
        <div
          className="row g-4 justify-content-center"
          style={{
            backgroundColor: "#DCCE9E",
            borderRadius: "30px",
          }}
        >
          {ministers.map((item: any, index: number) => (
            <div
              key={index}
              className="col-12 col-lg-4 d-flex align-items-stretch"
            >
              <div className="text-center w-100 p-3">
                {/* Image */}
                <div
                  className="rounded-circle bg-white mx-auto mb-3 d-flex align-items-center justify-content-center"
                  style={{
                    width: "120px",
                    height: "120px",
                    overflow: "hidden",
                    border: "1px solid #bfbdb8",
                  }}
                >
                  {item?.fileUrl ? (
                    <img
                      src={`${base_Url}${item.fileUrl}`}
                      alt={item.name}
                      className="rounded-circle"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  ) : (
                    <i
                      className="bi bi-person"
                      style={{ fontSize: "2rem", color: "#adb5bd" }}
                    />
                  )}
                </div>

                {/* Name */}
                <h6
                  className="fw-bold mb-1"
                  style={{
                    fontSize: "clamp(0.875rem, 2.5vw, 1rem)",
                    color: "#1A5319",
                  }}
                >
                  {item.name}
                </h6>

                {/* Title + Designation */}
                <p
                  className="fw-semibold mb-0"
                  style={{
                    fontSize: "clamp(0.8rem, 2vw, 0.9rem)",
                    color: "#595959",
                  }}
                >
                  {item.title}
                  <br />
                  {item.designation}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MinisterNew;
